import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';
import { DISASTER_TYPE_LIST, DISASTER_YEARLIST } from '../disaster-monitoring-map/disaster-monitoring-map-constants';

@Component({
  selector: 'app-disaster-monitoring-sidebar',
  templateUrl: './disaster-monitoring-sidebar.component.html',
  styleUrls: ['./disaster-monitoring-sidebar.component.scss']
})
export class DisasterMonitoringSidebarComponent implements OnInit {

  disasterList:any = []
  sourceList: any = [
    { key: 'EM-DAT', value: 'EM_DAT' },
    { key: 'WEB AGENT', value: 'WEB_AGENT' }
  ]
  yearList: any = [] //[{ key: '2020', value: '2020' }, { key: '2021', value: '2021' }, { key: '2022', value: '2022' }, { key: '2023', value: '2023' }, { key: '2024', value: '2024' }, { key: '2025', value: '2025' }]
  stateList: any = [{ key: 'Andhra Pradesh', value: 'cdf94322-30bf-456b-b0c6-b4038caebd6a' }]
  selectedYear: any = 'ALL'
  selectedState: any = ''
  selectedDistrict: any = ''
  selectedMandal: any = ''
  queryParams: any = {};
  isInitialLoad: boolean = false;
  selectedDisasterType: any = 'Flood'
  selectedSourceType: any;
  locType: any = 'COUNTRY';

  constructor(private route: ActivatedRoute, private router: Router, private gisUtils: UtilsService) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe((params: Params) => {
      this.queryParams = {};
      for (const param in params) {
        if (params.hasOwnProperty(param)) {
          this.queryParams = params[param];
          this.selectedState = this.queryParams['location'].split('&')[1] ? this.queryParams['location'].split('&')[1] : ''
          this.selectedDisasterType = isNullOrUndefined(this.queryParams.disasterType) ? 'Flood' : this.queryParams.disasterType
          this.selectedSourceType = this.queryParams.source
          this.disasterList = DISASTER_TYPE_LIST[this.selectedSourceType]
          this.yearList = DISASTER_YEARLIST[this.selectedSourceType]
          this.selectedYear = isNullOrUndefined(this.queryParams.year) ? 'ALL' : this.queryParams.year
        }
      }
      if (!isNullOrUndefined(this.queryParams)) {
        this.isInitialLoad = true
        this.requestSelectedFilterParams()
      }
    })
  }

  onSubmit() {
    let options = { ...this.queryParams }
    options['year'] = this.selectedYear
    options['disasterType'] = this.selectedDisasterType
    options['source'] = this.selectedSourceType

    // options['locType'] = this.locType
    // if (this.locType == 'STATE') {
    //   options['pUUID'] = this.selectedState.split('##')[1]
    //   options['locName'] = this.selectedState.split('##')[0]
    //   const locationInfo = this.selectedState
    //   options['location'] += '&' + locationInfo
    // }
    this.router.navigate(['.'], {
      relativeTo: this.route,
      queryParams: options,
      queryParamsHandling: 'merge'
    })
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    // if (!this.isInitialLoad) {
    //   currentUrlParams = this.selectedParams;
    // }
    currentUrlParams['component'] = 'DISASTERMONITORING';
    currentUrlParams['src'] = 'IMD_GRID'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'ADMIN';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      this.gisUtils.selectedParams.next(currentUrlParams);
      this.isInitialLoad = false
    }
  }

  onSourceSelect() {
    this.disasterList = DISASTER_TYPE_LIST[this.selectedSourceType]
    this.yearList = DISASTER_YEARLIST[this.selectedSourceType]
    this.selectedDisasterType = 'Flood'
    this.selectedYear = 'ALL'
  }

}
